<!--SideNavigationBar.vue -->
<template>
  <v-navigation-drawer v-model="displayBool" color="navigationdrawer" :width="isPhoneBool ? '100vw' : NavMenuWidth"
    class="toplited" :mini-variant="onlyIconMode" :left="!isInverted ? true : false" :right="isInverted ? true : false"
    app clipped>
    <v-container class="maxheightconatiner pa-0 d-flex flex-column">

      <v-row no-gutters class="logobackground">
        <v-col cols="12" class="d-flex px-0 pt-1 justify-space-between autoheight">
          <router-link :to="{ name: 'Home' }" class="text-decoration-none" v-slot="{ navigate }" custom>
            <v-img :src="logosrc" @click="navigate" height="28" :max-width="maxLogoWidth"
              :class="onlyIconMode ? 'mt-3 mb-2 ml-2' : 'ml-2 mt-3'" style="cursor: pointer;"
              :style="NavMenuWidth > 200 ? 'margin-top: 8px !important;' : ''">
            </v-img>
          </router-link>
          <icon-btn v-if="isPadBool" @click.native="navTrigger()" :icon="'mdi-close'" :size="35" :color="'close'"
            class="mr-4 mt-2">
          </icon-btn>
        </v-col>
        <v-col cols="12" class="px-2 closertop" style=" padding-bottom: 1px;">
          <v-list-item-title v-if="!onlyIconMode"
            :style="NavMenuWidth > 200 ? 'opacity: 1; padding-top: 4px;' : 'opacity: 0; '"
            class="font-weight-bold useThemeTextColor smallertext">
            Equipment service made simple.
          </v-list-item-title>
        </v-col>
      </v-row>

      <SideNavigationBarItems v-if="isPhoneBool" />
      <TwoStepSideNavigationBarItems v-else @showChildPanel="e => showChildPanel = e" />

      <v-card color="background" class="forward">
        <v-divider />
        <!-- 
        <nav-drawer-trigger v-if="isPcBool" :li="onlyIconMode ? 'small' : true">
        </nav-drawer-trigger>
        -->
        <avatar-btn></avatar-btn>
      </v-card>
    </v-container>
  </v-navigation-drawer>
</template>


<script>
import IconBtn from "@/components/Buttons/IconBtn.vue";
import SideNavigationBarItems from "@/components/Sections/AppSections/SideNavigationBarItems.vue";
import TwoStepSideNavigationBarItems from "@/components/Sections/AppSections/TwoStepSideNavigationBarItems.vue";
import NavMixin from "@/helpers/Mixins/NavMixin.js";
//import NavDrawerTrigger from "@/components/Buttons/NavDrawerTrigger.vue";
import AvatarBtn from "@/components/Buttons/AvatarBtn.vue";

export default {
  components: {
    IconBtn,
    //NavDrawerTrigger,
    AvatarBtn,
    SideNavigationBarItems,
    TwoStepSideNavigationBarItems,
  },
  mixins: [NavMixin],

  data() {
    return {
      displayBool: this.isPadBool,
      showChildPanel: false,
    };
  },

  mounted() {
    this.$store.dispatch("navstore/initiateNavMenuExtended");
  },

  methods: {
    navTrigger() {
      this.$store.dispatch("navstore/triggerNavMenu");
    },
  },

  computed: {
    logosrc() {
      return require(this.onlyIconMode ? "@/assets/logosmall.png" : "@/assets/text-loader-animation.svg");
    },

    isInverted() {
      return this.$store.getters["prefrences/Prefrence"]("InvertedLayout");
    },

    maxLogoWidth() {
      if (this.onlyIconMode) {
        return 36;
      }
      else {
        if (this.ClientHeight < 730) {
          return 52;
        }
        else {
          return 65;
        }
      }
    },

    NavMenuWidth() {
      var customWidth = this.$store.getters["prefrences/Prefrence"]("NavMenuWidth");
      if (this.showChildPanel && customWidth) {
        return customWidth;
      }
      else {
        var firstepWidth;
        if (this.ClientHeight > 1090) {
          firstepWidth = 95;
        }
        else if (this.ClientHeight < 730) {
          firstepWidth = 65;
        }
        else {
          firstepWidth = 85;
        }
        return firstepWidth;
      }
    },
  },

  watch: {
    showNav: function () {
      this.displayBool = !this.displayBool;
    },
  },
};
</script>



<style lang="scss">
.toplited {
  z-index: 100;
}

.maxheightconatiner {
  height: calc(100vh - 30px) !important;
}

.maxheight {
  max-height: 100%;
  overflow: overlay;
  /*border-top: 1px solid rgb(238, 238, 238);*/
}

@-moz-document url-prefix() {

  //Firefox does not support overlay overflow, and interprets it as none instead of auto.
  .maxheight {
    overflow: auto;
  }
}

.minheight {
  min-height: 100%;
}

.forward {
  position: relative;
  z-index: 20;
  margin-left: -1px;
}

div::-webkit-scrollbar {
  width: 11px;
}

div::-webkit-scrollbar-track {
  /*background: #e6e6e6;
  border-left: 1px solid #dadada;*/
}

div::-webkit-scrollbar-thumb {
  background: #b0b0b0;
  border: solid 3px #e9e9e9;
  border-radius: 7px;
}

div::-webkit-scrollbar-thumb:hover {
  background: rgb(121, 121, 121);
}

.closertop {
  margin-top: -4px;
  margin-bottom: 4px;
}

.logobackground {
  flex-grow: 0;
}

.smallertext {
  font-size: 12px !important;
}

.spacerli {
  min-height: 20px !important;
  max-height: 20px !important;
}
</style>
